import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-blue-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="text-center mb-4">
              <div className="text-2xl font-bold text-white mb-1" style={{ fontFamily: '"Pacifico", serif' }}>
                Zhongming Import
              </div>
              <div className="text-sm font-medium text-blue-200 tracking-wide">
                Soluciones Profesionales B2B
              </div>
            </div>
            <p className="text-blue-200 mb-6 leading-relaxed">
              Líderes en importación de materiales de construcción y decoración desde China. Calidad certificada y servicio profesional para el sector B2B.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-blue-900 rounded-lg hover:bg-blue-800 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-blue-900 rounded-lg hover:bg-blue-800 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-blue-900 rounded-lg hover:bg-blue-800 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-blue-900 rounded-lg hover:bg-blue-800 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('hero')} className="text-blue-200 hover:text-white transition-colors cursor-pointer">
                  Inicio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-blue-200 hover:text-white transition-colors cursor-pointer">
                  Nuestros Servicios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('catalog')} className="text-blue-200 hover:text-white transition-colors cursor-pointer">
                  Catálogo B2B
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('projects')} className="text-blue-200 hover:text-white transition-colors cursor-pointer">
                  Proyectos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-blue-200 hover:text-white transition-colors cursor-pointer">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Servicios</h4>
            <ul className="space-y-3">
              <li className="text-blue-200">Importación Directa</li>
              <li className="text-blue-200">Control de Calidad</li>
              <li className="text-blue-200">Logística Integral</li>
              <li className="text-blue-200">Asesoramiento Técnico</li>
              <li className="text-blue-200">Certificaciones</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-blue-400 mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <span className="text-blue-200">C/ PICO DE LA CIERVA 1<br />28031 - MADRID</span>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line text-blue-400 mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <span className="text-blue-200">+34 688 06 61 41</span>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-blue-400 mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <span className="text-blue-200">info@zhongmingimport.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-blue-900">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-blue-300 text-sm mb-4 md:mb-0">
              © 2024 Zhongming Import. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy-policy" className="text-blue-300 hover:text-white text-sm transition-colors cursor-pointer">
                Política de Privacidad
              </Link>
              <Link to="/terms-conditions" className="text-blue-300 hover:text-white text-sm transition-colors cursor-pointer">
                Términos y Condiciones
              </Link>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-blue-300 hover:text-white text-sm transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
